
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

define('component!KeyboardShortcutsModalComponent',['require','react','create-react-class','component!ModalComponent','translate','underscore','lib/Podio.Utils'],function (require) {
  'use strict';

  var React = require('react');
  var ReactCreateClass = require('create-react-class');

  var ModalComponent = require('component!ModalComponent');

  var t = require('translate');
  var _ = require('underscore');

  var utils = require('lib/Podio.Utils');

  var globalShortcutMap = {
    'g': t('Open workspace switcher #shortcut.modal'),
    's': t('Focus search bar #shortcut.modal'),
    'c': t('Open/Close chat #shortcut.modal'),
    'm': t('Start new message #shortcut.modal'),
    't': t('Create task #shortcut.modal'),
    '?': t('Bring up this help dialog #shortcut.modal'),
    'n': t('Open Notifications #shortcut.modal')
  };

  var notificationShortcutMap = {
    'k': t('Select previous notification #shortcut.modal'),
    'j': t('Select next notification #shortcut.modal'),
    'o': t('Open selected notification #shortcut.modal'),
    's': t('Star selected notification #shortcut.modal')
  };

  var itemShortcutMap = {
    'l': t('Like an item #shortcut.modal'),
    'h': t('Show or hide empty fields in an item #shortcut.modal'),
    '←': t('Previous item when viewing in an app #shortcut.modal'),
    '→': t('Next item when viewing in an app #shortcut.modal')
  };

  var appShortcutMap = {
    'f': t('View your app in full-screen mode #shortcut.modal'),
    'v': t('Toggle the layout for an application #shortcut.modal')
  };

  var KeyboardShortcutsModalComponent = ReactCreateClass({
    displayName: 'KeyboardShortcutsModalComponent',

    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      this.modal = React.createRef();
    },

    render: function render() {
      return React.createElement(
        ModalComponent,
        _extends({}, this.props, { ref: this.modal, className: 'keyboard-shortcuts-modal-component' }),
        React.createElement(
          'div',
          { className: 'modal-wrapper' },
          React.createElement(
            'h1',
            { className: 'modal-header header-title' },
            t('Keyboard shortcuts #shortcut.modal')
          ),
          React.createElement(
            'div',
            { className: 'modal-content' },
            React.createElement(
              'div',
              { className: 'shortcuts' },
              React.createElement(
                'div',
                { className: 'shortcuts__left' },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'h3',
                    null,
                    t('Site wide shortcuts #shortcut.modal')
                  ),
                  this.renderShortcuts('global')
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'h3',
                    null,
                    t('Apps #shortcut.modal')
                  ),
                  this.renderShortcuts('apps')
                )
              ),
              React.createElement(
                'div',
                { className: 'shortcuts__right' },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'h3',
                    null,
                    t('Notifications #shortcut.modal')
                  ),
                  this.renderShortcuts('notifications')
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'h3',
                    null,
                    t('Items #shortcut.modal')
                  ),
                  this.renderShortcuts('items')
                )
              )
            )
          )
        )
      );
    },

    renderShortcuts: function renderShortcuts(type) {
      var shortcutMap = {
        'global': globalShortcutMap,
        'notifications': notificationShortcutMap,
        'apps': appShortcutMap,
        'items': itemShortcutMap
      };

      return _.map(shortcutMap[type], function (value, key) {
        return React.createElement(
          'div',
          { key: key },
          React.createElement(
            'div',
            { className: 'image-block' },
            React.createElement(
              'div',
              { className: 'img' },
              React.createElement(
                'div',
                null,
                key
              )
            ),
            React.createElement(
              'div',
              { className: 'bd' },
              React.createElement(
                'span',
                null,
                value
              )
            )
          )
        );
      });
    },

    open: function open() {
      this.modal.current.open();
    }
  });

  return KeyboardShortcutsModalComponent;
});
